import '../../global'
import { collection, getDocs, onSnapshot, query, where } from 'firebase/firestore'
import { db } from '../../firebase/config'
import { convertHours } from '../../helpers/prepTimeFunctions'

function formatCuisines(cuisines) {
	if (cuisines) {
		return cuisines.map(cuisine => {
			return cuisine.toLowerCase()
		})
	}
}

export function formatRestaurantData(data: any) {
	const prepTime = global.ignorePrepTimeAtClose ? 0 : data.prepTime ? data.prepTime : 15
	return {
		heroImg: data.images && data.images.hero ? data.images.hero : '',
		logoImg: data.images && data.images.logo ? data.images.logo : '',
		name: data.name,
		id: data.id,
		hours: convertHours(data.hours, prepTime),
		timezone: data.timezone,
		address: data.address,
		prepTime: data.prepTime ?? 15,
		social: data.social ?? {},
		schedulingJump: data.scheduleJump ?? 15,
		isSnoozed: data.isSnoozed ?? false,
		snoozeUntil: data.snoozeUntil ?? -1,
		cuisines: formatCuisines(data.cuisines) ?? [],
		isTest: data.isTest ?? false,
		slug: data.slug,
		isEnabled: data.isEnabled ?? false,
		seo: data.seo ?? {},
		description: data.description ?? '',
	}
}

export const getRestaurantData = () => {
	return new Promise((resolve, reject) => {
		const dataImport = {}
		const restaurantRef = collection(db, 'Restaurants-v2')
		onSnapshot(
			restaurantRef,
			snapshot => {
				snapshot.docChanges().forEach(change => {
					const data = change.doc.data()
					if (!data.isDeleted) {
						const restaurantReturn = formatRestaurantData({
							...data,
							id: change.doc.id,
						})

						// Use the document ID as the key
						dataImport[change.doc.id] = restaurantReturn
					}
				})
				resolve(dataImport)
			},
			reject
		)
	})
}
